export default {
	"notice": {
		"createdDt": "message generation time",
		"readDt": "Message reading time",
		"unread": "unread"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/notice/notice.js